package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_22_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have teleported to Bondōvriar and are preparing for a trek into the Greatmarsh. Zolnur tells the heroes that he sent word to a colleague of his who can guide adventurers. Caper demands that the group should leave as quickly as possible, but the heroes are able to convince her to stay one day to make preparations as long as they leave first thing the next morning. Caper and Tuesday play their instruments while the heroes walk to Drolo’s Apothecary. Are the townsfolk staring because Caper and Tuesday look so unusual or because they act so strangely?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes arrive at Drolo’s Apothecary. A plain-looking halfling male wearing glasses sets down his book and greets the heroes. Tuesday says that he wants the prettiest potion, then later denies that he said this. Annette shifts the conversation to healing potions. Caper tries to haggle. Tuesday eventually opens up an opportunity for a deal. Falorn buys three greater healing potions and distributes them to the melee.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to Grey Goat Inn around 9pm.")
    }
}
